// extracted by mini-css-extract-plugin
export default {"container":"Home_container__cF+Wd","dynamicTitle":"Home_dynamicTitle__vmRfg","dynamicTitleh2":"Home_dynamicTitleh2__KGsqL","dynamicTitleh3":"Home_dynamicTitleh3__GV+sN"};